









import Vue from 'vue';
import { mapState } from 'vuex';
import { ILookupType, LocationLookupType } from '@/Stores/LookupStore';

export default Vue.extend({
    name: 'LocationLookupDropdown',
    props: {
        location: { type: String },
        type: {
            validator: (value: keyof typeof LocationLookupType) => {
                if (LocationLookupType[value] || LocationLookupType[value] === 0) {
                    return true;
                }
                return false;
            },
        },
        value: {
            required: true,
        },
        css: { type: String },
        dropdownId: { type: String },
        parentCode: { type: String, required: false },
        placeholder: { type: String, required: false },
        allowUnset: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        ...mapState({
            lookups(state: any): { [code: string]: ILookupType } {
                if (!this.location) {
                    return {};
                }

                const loc = state.lookupsModule.locationLookups;

                if (!loc[this.location]) {
                    return {};
                }

                const types = loc[this.location][this.lookupType];

                if (!types) {
                    return {};
                }

                return types;
            },
        }),
        disableDropdown(): boolean {
            return this.disabled || this.noOptions;
        },
        noOptions(): boolean {
            return  !this.filteredLookups || !this.filteredLookups.length;
        },
        placeholderText(): string {
            return (this.allowUnset && this.selected !== null) ?
                this.$t('shared.dropdown.unsetLabel').toString() :
                    (this.noOptions ? 'N/A' : (this.placeholder || this.$t('common.select') as string));
        },
        lookupType(): LocationLookupType {
            if (typeof this.type === 'string') {
                return LocationLookupType[this.type];
            }
            return this.type;
        },
        filteredLookups(): { [code: string]: ILookupType } {
            if (!this.parentCode) {
                return this.lookups;
            }

            const filteredLookups: { [code: string]: ILookupType } = {};

            for (const key in this.lookups) {
                if (!this.lookups.hasOwnProperty(key)) {
                    continue;
                }

                const lookupType = this.lookups[key];
                if (lookupType.parentCode === this.parentCode) {
                    filteredLookups[key] = lookupType;
                }
            }

            return filteredLookups;
        },
        sortedLookups(): ILookupType[] {
            let arr: ILookupType[];
            arr = [];

            for (const fl in this.filteredLookups) {
                if (!this.filteredLookups.hasOwnProperty(fl)) {
                    continue;
                }

                arr.push(this.filteredLookups[fl]);
            }

            return arr.sort((x, y) => (x.order ?? 0) - (y.order ?? 0));
        }
    },
    async mounted() {
        if (this.value === undefined) {
            this.selected = null;
        }
        await this.loadLookups(this.location);
    },
    data() {
        return {
            selected: this.value as (string | null)
        };
    },
    methods: {
        async loadLookups(location: string): Promise<{ [code: string]: ILookupType }> {
            return await this.$typedStore.modules.lookupsModule.actions.getLocationLookups({
                location,
                lookupType: this.lookupType
            });
        },
        onChange(e: Event) {
            const sel = (e.target as HTMLSelectElement);
            if (sel.selectedIndex > 0) {
                this.$emit('description', sel.options[sel.selectedIndex].text);
            }
        }
    },
    watch: {
        async location(newLocation: string) {
            await this.loadLookups(newLocation);
        },
        selected(selected: string) {
            this.$emit('input', selected);
        },
        parentCode() {
            this.selected = null;
        },
        value(value: string) {
            this.selected = value?.trim() ?? '';
        },
    },
});
